import React from 'react';
import ReactDOM from 'react-dom';

import { Router, Route, Redirect, browserHistory } from 'react-router';

import registerServiceWorker from './registerServiceWorker';

// import {scrollToTop} from './js/scrollTop';

import './css/reset.css';
import './css/util.css';
import './css/common.css';

ReactDOM.render(
	<Router history={ browserHistory }>
		<Route path='/'
			   getComponent={ (state, cb) => {
					   require.ensure([], require => {
						   cb(null, require('./pages/container').default);
					   });
				   }
			   }
		/>
		<Redirect from='*' to='/' />
	</Router>,
	document.getElementById('root')
);

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js